import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import useInput from "../../utils/useInput";

const ResetPassword = () => {
  const { otp: incomingOtp, userId } = useParams();

  const [otp, bindOtp] = useInput(incomingOtp);
  const [newPassword, bindNewPassword] = useInput("");
  const [confirmNewPassword, bindConfirmNewPassword] = useInput("");

  const [message, setMessage] = useState(null);
  let navigate = useNavigate();

  const FormSubmitHandler = async (e) => {
    e.preventDefault();
    let form = { userId, otp, newPassword, confirmNewPassword };

    await fetch(
      "https://atease-insurance.herokuapp.com/user/verification/password/reset",
      {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify(form),
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.status === "FAILED") {
          setMessage(data.message);
          setTimeout(() => {
            setMessage(null);
          }, 3000);
        } else {
          if (data.status === "SUCCESS") {
            setMessage(data.message);
            setTimeout(() => {
              navigate("/login");
            }, 3000);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div>
      <div className="limiter mt-vh-20">
        <div className="container-login100">
          <div className="wrap-login100">
            <form
              onSubmit={FormSubmitHandler}
              className="login100-form validate-form"
            >
              <span className="login100-form-title">Reset Your Password</span>

              <div
                className="wrap-input100 validate-input"
                data-validate="OTP is required"
              >
                <span className="label-input100">OTP</span>
                <input
                  className="input100"
                  type="text"
                  placeholder="Type in your OTP"
                  {...bindOtp}
                />
                <span className="focus-input100 email"></span>
              </div>

              <div
                className="wrap-input100 validate-input"
                data-validate="New Password is required"
              >
                <span className="label-input100">New Password</span>
                <input
                  className="input100"
                  type="password"
                  placeholder="Type in your new password"
                  {...bindNewPassword}
                  autoComplete="off"
                />
                <span className="focus-input100 email"></span>
              </div>

              <div
                className="wrap-input100 validate-input"
                data-validate="Confirm Password is required"
              >
                <span className="label-input100">Confirm New Password</span>
                <input
                  className="input100"
                  type="password"
                  placeholder="Confirm your new password"
                  autoComplete="off"
                  {...bindConfirmNewPassword}
                />
                <span className="focus-input100 email"></span>
              </div>

              <div className="container-login100-form-btn p-t-100">
                <div className="wrap-login100-form-btn">
                  <div className="login100-form-bgbtn"></div>
                  <button type="submit" className="login100-form-btn">
                    Send
                  </button>
                </div>
              </div>
            </form>

            {message && <p className="text-center p-t-100">{message}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
